module.exports = __webpack_public_path__ + "media/assets/icons/female_icon-f8e6f4c43db0df6686d96da609e0cbd0.svg";